import React, { useState } from 'react';
import { initialize as initializeChat } from '../../services/chat';
import { FloatingButton } from '@husslehq/ui-library';

export const Chat: React.FC = () => {
  const [zendeskLoaded, setZendeskLoaded] = useState(false);
  const [zendeskLoading, setZendeskLoading] = useState(false);

  const openZendesk = () => {
    if (window !== undefined) {
      setZendeskLoading(true);
      if (!zendeskLoaded) {
        initializeChat();
        (window as any).zESettings = {
          webWidget: {
            chat: {
              suppress: false,
            },
          },
        };
        openChatPopup();
      } else {
        reOpenChatPopup();
      }
    }
  };

  const openChatPopup = () => {
    (window as any).zE(function () {
      (window as any).$zopim(function () {
        (window as any).$zopim.livechat.setOnConnected(function () {
          setTimeout(function () {
            (window as any).zE.activate({ hideOnClose: true });
            setZendeskLoaded(true);
            setZendeskLoading(false);
          }, 100);
        });
      });
    });
  };

  const reOpenChatPopup = () => {
    (window as any).zE(function () {
      (window as any).$zopim(function () {
        setTimeout(function () {
          (window as any).zE.activate({ hideOnClose: true });
          setZendeskLoading(false);
        }, 100);
      });
    });
  };

  return (
    <FloatingButton onClick={() => openZendesk()} isLoading={zendeskLoading}>
      Talk to us
    </FloatingButton>
  );
};
